module.exports = __webpack_public_path__ + "img/xiala-more.01e0bf87.png";